import { FC, useState } from 'react';

import HighlightedText from 'common/components/custom/highlighted-text/HighlightedText';
import { RadioButton } from 'common/components';

import './SearchList.scss';
import { EntityType } from 'common/enums';
import { EntityVM } from 'common/models/data/entity.model';

type SearchListProps = {
    searchVal: string;
    data: any;
    handleChangeForSearch: (event: React.ChangeEvent<HTMLInputElement>, list: any) => void;
    radioButtonForSearch: string;
    hideSelectionOnCategory?: boolean;
    disbleEntity?: EntityVM;
    preventSelectionOfSubCategoriesHavingSubCategories?: boolean;
    preventSelectionOfSubCategoriesHavingIndicators?: boolean;
};

const SearchList: FC<SearchListProps> = ({
    searchVal,
    data,
    radioButtonForSearch,
    handleChangeForSearch,
    disbleEntity,
    hideSelectionOnCategory,
    preventSelectionOfSubCategoriesHavingSubCategories,
    preventSelectionOfSubCategoriesHavingIndicators
}: SearchListProps) => {
    const getRadioButton = () => {
        if (hideSelectionOnCategory && data.entityType === EntityType.Category) {
            return (
                <RadioButton
                    name="searchList"
                    id={data.id}
                    value={data.id}
                    disabled={true}
                    className="whats-new-radio-button"
                    checked={radioButtonForSearch === data.id}
                    onChange={(event) => handleChangeForSearch(event, data)}>
                    <div className="search-content">
                        <div className="search-text">
                            <HighlightedText text={data.name} highlight={searchVal} />
                        </div>
                        <div className="search-breadcrumb">{data.path}</div>
                    </div>
                </RadioButton>
            );
        } else if (
            (disbleEntity &&
                disbleEntity.entityType === EntityType.Category &&
                disbleEntity.id === data.id) ||
            (disbleEntity &&
                disbleEntity.entityType === EntityType.SubCategory &&
                disbleEntity.hierarchyId === data.hierarchyId) ||
            (preventSelectionOfSubCategoriesHavingSubCategories &&
                data.entityType === EntityType.SubCategory &&
                data.hasChild &&
                !data.hasChildIndicatorsOnly) ||
            (preventSelectionOfSubCategoriesHavingIndicators &&
                data.entityType === EntityType.SubCategory &&
                data.hasChildIndicatorsOnly)
        ) {
            return (
                <RadioButton
                    name="searchList"
                    id={data.id}
                    value={data.id}
                    disabled={true}
                    className="whats-new-radio-button"
                    checked={radioButtonForSearch === data.id}
                    onChange={(event) => handleChangeForSearch(event, data)}>
                    <div className="search-content">
                        <div className="search-text">
                            <HighlightedText text={data.name} highlight={searchVal} />
                        </div>
                        <div className="search-breadcrumb">{data.path}</div>
                    </div>
                </RadioButton>
            );
        } else {
            return (
                <RadioButton
                    name="searchList"
                    id={data.id}
                    value={data.id}
                    className="whats-new-radio-button"
                    checked={radioButtonForSearch === data.id}
                    onChange={(event) => handleChangeForSearch(event, data)}>
                    <div className="search-content">
                        <div className="search-text">
                            <HighlightedText text={data.name} highlight={searchVal} />
                        </div>
                        <div className="search-breadcrumb">{data.path}</div>
                    </div>
                </RadioButton>
            );
        }
    };
    return (
        <>
            <div className="search-container">{getRadioButton()}</div>
        </>
    );
};

export default SearchList;
